import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { ImageItem } from '@ngx-gallery/core';
import { Subscription } from 'rxjs';
import { ImageGalleryModalComponent } from 'src/app/shared/components/image-gallery-modal/image-gallery-modal.component';
import { ISeo, IActiveProduct } from 'src/app/shared/models';
import { IProduct, IProductDetail, IReviewsData, IUpgradeProduct } from 'src/app/shared/models/product-detail-payload.interface';
import { ApiService, UtilsService, MatDialogUtilsService } from 'src/app/shared/services';
import { EnvService } from 'src/app/shared/services/env.service';
import { PixelService } from 'src/app/shared/services/facebook-pixel/pixel.service';

@Component({
  selector: 'app-product-preview-panel',
  templateUrl: './product-preview-panel.component.html',
  styleUrls: ['./product-preview-panel.component.less']
})
export class ProductPreviewPanelComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() paramSku: string = ''
  @Output() close = new EventEmitter();
  @Input() isHandset: boolean;
  @Input() urlVariant = '';
  @Input() productDetails: any;


  @ViewChild("topContainer", { static: false }) topContainer: ElementRef;
  @ViewChild("gallery", { static: false }) galleryContainer: ElementRef;
  @ViewChild("itemTemplate", { static: true }) itemTemplate: TemplateRef<any>;
  @ViewChild("productShare", { static: true }) productShare: TemplateRef<any>;



  product: IProduct;
  seoData: ISeo;
  productSubscription: Subscription;
  eventSubscription: Subscription;
  routeSubscription: Subscription;
  Math: Math = Math;
  selectedIndex: number;
  descriptionExist: boolean;
  isSwatchExist: boolean;
  isVariationExist: boolean;
  isProductFetching = true;
  showDetails = false;
  spinner = "assets/image/spinner.gif";
  description: any;
  productPrice: any;
  productWasPrice: any;
  variations = [];
  topHeight = { "max-height": "0" };
  swatches = [];
  errorMessage = "";

  activeTab = "mr";
  priceData = {
    price: "",
    wasPrice: "",
  };
  selectedSwatch = {
    swatch_image: null,
    price: "",
    wasPrice: "",
  };
  hasValidWasPrice = true;
  quantity = 1;
  quantityArray = [];
  isSetItemInInventory = false;
  localStorageUser = {};
  activeProduct: IActiveProduct;
  hasSelection: boolean;
  beforeSelection: boolean;
  checkSelection: boolean;
  schema = {};
  invalidLinkImageSrc = "assets/image/invalid_link.png";
  invalidLink: boolean;
  starIcons = [];
  recentProducts: any[] = [];
  recentReviews: IReviewsData;

  upgradeProducts: IUpgradeProduct[];
  otherPeopleProducts = [];

  mainProductImage = [];
  serverProductImagesWithIndex = [];

  showSku = false;
  productSku = "";
  pKey: string;
  updatedPrice: any;
  slideIndex = 0;
  newVariationFound: boolean;
  newVariationData: any;
  dupProduct: IProduct;
  prodBoardList: any[] = [];
  perRowCount: number;
  isPriceUpdate: boolean;
  brandCoverImg: any;
  newSku: string = "";
  salePriceStrike: number;
  onlySkuDetails: boolean;
  appUrl = '';
  nos: number;
  assetBaseUrl: string;
  desktopImageUrl: string;
  mobileImageUrl: string;
  showBanner: boolean = false;
  brandUrl: any;
  showViewOnLoader = true;
  isVariationCallLoading = false;
  showLoader = true;
  @Input() roomId: string;
  @Input() page: string;


  @Input() projectOptions: any[] = []
  selectedBookingId :number;
  isSingleDimension: boolean;
  dimensionExist: boolean;

  productImages: any[];
  features: string;
  height: number;
  width: number;
  isImgLoaded: boolean;
  isCopied: boolean;
  isPinned: boolean;
  @Output() emitPin = new EventEmitter();

  dimensionGallery: string[] = [];

      searchCtrl = new FormControl('');
      filteredRoomOptions: any[]=[];  
  designPriceFromSelection: number=0;

  constructor(
    private apiService: ApiService,
    public utils: UtilsService,
    public snackbar: MatSnackBar,
    private matDialog: MatDialog,
    private matDialogUtils: MatDialogUtilsService,
    private pixelService: PixelService,
    private activeRoute: ActivatedRoute,
    public env: EnvService,
    private location: Location,
    private cdRef:ChangeDetectorRef
  ) {
    this.appUrl = this.env.appUrl;
    this.utils.showCatNav = false;
  }
  getmsg(d) {
    return this.utils.compileMarkdownText(d)
  }


  pin() {
    this.isPinned = !this.isPinned;
    this.emitPin.emit(this.isPinned)
  }
  viewDetails() {
    window.open(`/product/${this.paramSku}`, '_blank');
  }
userType = 0;

  ngOnInit(): void {
    if(this.projectOptions && this.projectOptions.length>0){
      this.filteredRoomOptions = JSON.parse(JSON.stringify(this.projectOptions));
  }

    this.searchCtrl.valueChanges.subscribe(searchText => {
      const search = searchText.toLowerCase();
      this.filteredRoomOptions = this.projectOptions?.filter(option =>
        option.displayName?.toLowerCase().includes(search) 
      );
    });
    this.onResize();
    const room = localStorage.getItem('currentRoom');
        this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;
        console.log(this.userType,'usertyper')

    if (room) {
      this.selectedBookingId = +room
    }
  }
  openGallery(img:string[]): void {
    this.matDialog.open(ImageGalleryModalComponent, {
      data: { gallery: img },
      panelClass: 'full-screen-dialog',
      maxWidth: '100vw',
      height: '0',
      autoFocus: false,
      restoreFocus: false
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;
    if (changes.paramSku && changes.paramSku.currentValue ) {
      this.product = null;
      this.isVariationCallLoading = true;
      this.isVariationExist = false;
      this.updatedPrice = null;
      this.designPriceFromSelection =0;
      this.isSetItemInInventory = false;
      this.newVariationFound = false;
      this.newSku = '';
      this.showSku = false;
      this.hasSelection = null; 
      this.newVariationData = null;
      this.isPriceUpdate = false;
      this.onlySkuDetails = true;
      this.activeProduct = null;
       this.productSku = ''; 
      this.loadProduct();
      const room = localStorage.getItem('currentRoom');
      if (room) {
        this.selectedBookingId = +room
      }
 
    }
  }
  resetSelection(e) {

  }

  closeDialog() {
    this.matDialog.closeAll();
  }

  catalogUrl = '';
  productUrl = '';

  shareProduct() {
    this.isCopied = false;
    if (this.page === 'product-catalogue') {
      this.matDialog.open(this.productShare, {
        width: '600px',
        height: 'auto',
        panelClass: 'share-product-dialog',
        disableClose: true
      })
    }
    const urlParams = new URLSearchParams(window.location.search);

    const filters = urlParams.get('filters') || '';
    const sortType = urlParams.get('sortType') || '';
    const pageNo = urlParams.get('pageNo') || '';

    const baseUrl = `${window.location.origin}/design/designer/products/all`;

    // Base query parameters
    const queryParts = [
      filters ? `filters=${filters}` : '',
      sortType ? `sortType=${sortType}` : '',
      pageNo ? `pageNo=${pageNo}` : '',
      `product=${this.paramSku}`
    ];

    // Check the condition to include variant
    const shouldIncludeVariant =
      (this.isVariationExist &&
        this.product.product_status === 'active' &&
        !this.product.redirect &&
        this.product.variations?.length > 0) ||
      (this.product.product_status === 'active' && (this.newVariationFound && this.newSku)
        || (!this.newVariationFound && this.showSku)
        && this.isPriceUpdate && this.updatedPrice > 0 && this.isSetItemInInventory && !this.onlySkuDetails);

    if (shouldIncludeVariant) {
      queryParts.push(`variant=${this.newSku || this.productSku}`);
    }

    const finalQuery = queryParts.filter(Boolean).join('&');
    const shareLink = `${baseUrl}?${finalQuery}`;
    this.catalogUrl = shareLink;
    this.productUrl = this.transformProductUrl(shareLink);

    if (this.page !== 'product-catalogue') {
      this.copyUrl(this.productUrl);
    }


  }

  transformProductUrl(inputUrl: string): string {
    const url = new URL(inputUrl);
    const product = url.searchParams.get('product');
    const variant = url.searchParams.get('variant');

    if (!product) return inputUrl; // fallback if product param is missing

    let result = `${url.origin}/product/${product}`;
    if (variant) {
      result += `?variant=${variant}`;
    }

    return result;
  }


  copyUrl(shareLink) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareLink)
        .then(() => {
          this.isCopied = true;
          if (this.page !== 'product-catalogue') {
            this.snackbar.open("Link copied to clipboard!", "x", { duration: 3112121000 });
          }
          console.log(shareLink);
        })
        .catch(() => {
          this.snackbar.open("Failed to copy the link.", "x", { duration: 3000 });
        });
    } else {
      this.snackbar.open("Clipboard API not supported.", "x", { duration: 3000 });
    }
  }
loading: boolean[] = [];
onImageLoad(index: number) {
  this.loading[index] = false;
}

onImageError(index: number) {
  // fallback: hide loader, maybe show a default placeholder
  this.loading[index] = false;
  this.productImages[index] = 'assets/placeholder.png';
}

  onSetNewImage(variation): void {
    this.mainProductImage = [];
    // if (variation && variation.image) {
    //   const src = variation.image.split(",");
    if (variation && variation.imagePath && variation.imagePath.length > 0) {
      this.loading.fill(true);
      const src = variation.imagePath;
      let images = [];
      if (this.isArray(src)) {
        images = [...src];
      } else {
        images[0] = new ImageItem({ src, thumb: src });
      }
      this.mainProductImage = [...images];
      if (variation.imagePath.length > 1) {
                this.product.product_images_gallery_thumb = Array.from(new Set([ ...images,  ...this.product.product_images_gallery_thumb]));
        // this.serverProductGalleryImagesWithIndex = this.product.product_images_gallery_thumb.map(
        //   (image, index) => { return { image, index }; });
      }
      //     if(images.length===1 && images[0]===this.productImages[0]){
      //   this.productImages = images;
      //   this.loading[0] = false;
      // } else {
      this.productImages = [...images,...this.productImages]
      // }
      this.isImgLoaded = false;
      this.loading.fill(false);

    } else {
      this.mainProductImage[0] = this.product.main_image;

    }
      setTimeout(() => {

      this.currentSlide(1,'product');
    }, 100);
  } 


  get scrollHeight() {
    return document.getElementById('rightPanel').clientHeight + 100;


  }

  get windowHeight() {
    return window.innerHeight;
  }
  ngAfterViewInit(): void {
    this.hideIntercomIcon();
  }
  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);
    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }



  loadProduct() {
    this.showLoader = true;
    this.quantity = 1;
    this.selectedBookingId = -1;
    
    const storedPreview = this.apiService.storedProductDetails.find(f => f.product.sku === this.paramSku
    );
    if (storedPreview) {
      this.processProductPayload(storedPreview);
      this.callProductSelection();
    } else {
      this.productSubscription = this.apiService
        .getProduct(this.paramSku)
        .subscribe(
          (payload: IProductDetail | any) => {
            this.apiService.storedProductDetails.push(payload);
            this.processProductPayload(payload);
            this.callProductSelection();
          },
          (error) => {
            this.invalidLink = true;
            this.isProductFetching = false;
          }
        );
    }



  }


  callProductSelection(){
    this.isVariationCallLoading = true;
    const storedSelection = this.apiService.storedProductSelection.find(f => f.sku === this.paramSku);
    if (storedSelection) {
      setTimeout(() => {
        this.processProductSelectionPayload(storedSelection);
      }, 1000);
    } else {
      this.apiService
        .getProductSelection(this.paramSku)
        .subscribe((data: any) => {
          this.apiService.storedProductSelection.push({ sku: this.paramSku, ...data });
          this.processProductSelectionPayload(data);
        }, err => {
          this.isVariationCallLoading = false;
        });
    }
  }

  processProductPayload(payload: any) {
    if (payload.product) {
      this.processProduct(payload);
      this.isSingleDimension = payload.product.dimension.length === 1;
      if (this.isSingleDimension) {
        this.dimensionExist =
          payload.product.dimension[0].groupValue[0].name ? true : false
      } else {
        this.dimensionExist = payload.product.dimension.length > 0;
      }
      this.dimensionGallery = payload.product.product_images_dims;
 
      if(this.dimensionGallery?.length>0){
     setTimeout(() => {
      this.currentSlide(1,'dims');
    }, 0);
      }
 
    } else {
      this.close.emit(payload.message);
    }
  }

  processProductSelectionPayload(data: any) {
    this.onlySkuDetails = false;
    if (data && data.selection && data.selection.length > 0) {
      this.newVariationFound = true;
      this.newVariationData = data;
      if (this.activeProduct) {
        this.activeProduct.in_inventory = true;
        if (!this.activeProduct.inventory_product_details.count) {
          this.activeProduct.inventory_product_details.count = 1;
        }
      }

    } else {
      let activeRecords = data.Skudetails?.find(f => f.is_active === 1);
      if (activeRecords) {
        this.onlySkuDetails = true;
        this.newVariationFound = true;
        this.newVariationData = data;
        this.newSku = activeRecords.sku;
      } else {
        this.newVariationFound = false;
      }
    }
    this.isVariationCallLoading = false;
  }




  private processProduct(payload: IProductDetail) {
    this.product = payload.product;
    this.features = this.utils.compileMarkdown(this.product.features);

    this.dupProduct = JSON.parse(JSON.stringify(payload.product));
    this.productImages = [];
    this.productImages.push(payload.product.main_image);
    this.product.product_images_gallery.forEach(f => {
      this.productImages.push(f);

    }) 
  this.loading = this.productImages.map(() => true);
    setTimeout(() => {
      this.currentSlide(1,'product');
    }, 0);
    if (
      this.product.variations.length === 0 &&
      this.product.product_status === "active"
    ) {
      this.isSetItemInInventory = true;
    }
    this.seoData = payload.seo_data;
    this.pixelService.trackViewContent(this.product);
    if (this.product.sku !== this.paramSku) {
      // this.router.navigateByUrl("/product/" + this.product.sku);
    }
    this.upgradeProducts = payload.upgrades || [];
    if (payload.product) {
      this.setProduct(payload);
    } else {
      this.invalidLink = true;
    }
    this.isProductFetching = false;
    if (
      Math.floor(this.product.min_price) ==
      Math.floor(this.product.max_price) ||
      Math.floor(this.product.min_price) >=
      Math.floor(this.product.min_was_price)
    ) {
      this.updatedPrice = JSON.parse(JSON.stringify(this.product.min_price));
    } else {
      this.updatedPrice = JSON.parse(JSON.stringify(this.product.max_price));
    }
    this.showLoader = false;
       this.cdRef.detectChanges();

       if(this.page==='client-shopping' || this.page ==='designer-shopping' ||  this.page ==='product-catalogue' 
         || (this.page==='ai-products' && this.canSeeDesignPricing)){  
            let finalPrice = (this.product && this.product.inventory_product_details) ?
                this.product.inventory_product_details.design_price ? this.product.inventory_product_details.design_price:
                  (this.product.inventory_product_details.price)
              ? this.product.inventory_product_details.price : this.product.min_price : this.product.min_price;
              let finalWasPrice =  (this.product && this.product.inventory_product_details && this.product.inventory_product_details.was_price)? this.product.inventory_product_details.was_price : this.product.min_was_price;
            
      
              this.product['price']=finalPrice;
                this.product['design_price'] = this.product.inventory_product_details.design_price;
                this.product['was_price'] = finalWasPrice;
                this.product['inv_price'] = this.product.inventory_product_details.price
 
        
       }
    
  }

  private setProduct(payload: IProductDetail) {
    this.updateActiveProduct(this.product);
    this.description = this.utils.compileMarkdown(
      this.product.description,
      true
    );
    this.descriptionExist = this.utils.checkDataLength(
      this.product.description
    );
    this.isSwatchExist = this.utils.checkDataLength(
      this.product.variations &&
      this.product.variations.filter(
        (variation) => variation.swatch_image !== null
      )
    );
    if (this.product.in_inventory) {
      this.productPrice = this.utils.formatPrice(
        this.product.inventory_product_details.price
      );
      this.productWasPrice = this.utils.formatPrice(
        this.product.inventory_product_details.was_price
      );
    } else {
      this.productPrice = this.product.min_price;

      this.productWasPrice = this.product.max_was_price;
    }
    if (typeof this.productPrice == "string") {
      const minPrice = Number(this.productPrice.split("-")[0]);
      const wasMinPrice = Number(this.productWasPrice.split("-")[0]);
      if (wasMinPrice <= minPrice) {
        this.hasValidWasPrice = false;
      }
    } else {
      const minPrice = Number(this.productPrice);
      const wasMinPrice = Number(this.productWasPrice);
      if (wasMinPrice <= minPrice) {
        this.hasValidWasPrice = false;
      }
    }

    this.isVariationExist = this.utils.checkDataLength(this.product.variations);

    if (!this.isVariationExist) {
      this.beforeSelection = true;
      this.checkSelection = true;
    }

    this.hasVariationsInventory();
    this.variations = this.product.variations.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
    if (this.product.set) {
      this.checkSetInventory(this.product.set);
    }
    if (!this.isVariationExist) { 
      this.showSku = true;
      this.productSku = (this.product.inventory_product_details && this.product.inventory_product_details.product_sku) ? 
      this.product.inventory_product_details.product_sku : this.product.sku;
    }
    if (this.isVariationExist && this.product.variations.length === 1) {
      this.beforeSelection = true;
      this.checkSelection = true;
      this.showSku = true;
      this.productSku = this.activeProduct.sku;
    }
    if (this.newVariationFound && this.newSku) {
      this.productSku = this.newSku;
    } else {
      this.productSku =
       (this.activeProduct.inventory_product_details && this.activeProduct.inventory_product_details.product_sku) ? 
      this.activeProduct.inventory_product_details.product_sku : this.activeProduct.sku;

    }

    this.invalidLink = false;
  }

  setSkuOfCurrentSelectedProduct(event) {
    if (event.data.length === 1) {
      this.showSku = true;
      this.productSku = event.data[0].variation_sku;
    } else {
      this.showSku = false;
      this.productSku = event.current ? event.current.variation_sku : '';
    }
  }
  onDestroy(): void {
    this.productSubscription.unsubscribe();
    this.eventSubscription.unsubscribe();
  }


  checkSetInventory(product) {
    for (const item of product) {
      if (item.in_inventory) {
        this.isSetItemInInventory = true;
      }
    }
  }

  isArray(obj: any) {
    return Array.isArray(obj);
  }



  onSetImage(variation): void {
    this.mainProductImage = [];
    if (variation && variation.imagePath && variation.imagePath.length > 0) {

      const src = variation.imagePath;
      let images = [];
      if (this.isArray(src)) {
        images = [...src];
      } else {
        images[0] =src// new ImageItem({ src, thumb: src });
      }
      this.mainProductImage = [...images];
      if (variation.imagePath.length > 1) {
                this.product.product_images_gallery_thumb = Array.from(new Set([ ...images,  ...this.product.product_images_gallery_thumb]));
        // this.serverProductGalleryImagesWithIndex = this.product.product_images_gallery_thumb.map(
        //   (image, index) => { return { image, index }; });
      }
      this.isImgLoaded = false;

      this.updateActiveProduct(variation);
      this.hasSelection = true;
    } else {
      // if(variation && variation.inventory_product_details){
      this.activeProduct.inventory_product_details = variation.inventory_product_details;

      // this.product.inventory_product_details = this.activeProduct.inventory_product_details
      // }
      this.updateActiveProduct(this.product);
      this.activeProduct.in_inventory = (variation.in_inventory === true || variation.in_inventory === false)
        ? variation.in_inventory : this.product.in_inventory;
      this.isSetItemInInventory = (this.activeProduct.in_inventory || this.activeProduct.inventory_product_details.is_active === 1) ? true : false;
      this.activeProduct.in_inventory = (this.activeProduct.in_inventory || this.activeProduct.inventory_product_details.is_active === 1) ? true : false;
      this.showSku = ((this.activeProduct.inventory_product_details &&
        this.activeProduct.inventory_product_details.product_sku) ||
        (this.activeProduct.sku)) ? true : false;

      this.mainProductImage[0] = this.product.main_image;
      this.hasVariationsInventory();
    }
  }

  get isUserLoggedIn(): boolean {
    if (JSON.parse(localStorage.getItem("user"))) {
      return (
        JSON.parse(localStorage.getItem("user")) &&
        JSON.parse(localStorage.getItem("user")).email &&
        JSON.parse(localStorage.getItem("user")).email.length > 0
      );
    } else {
      return false;
    }
  }



  onSetPrice(priceData): void {
    if (!this.productPrice.includes("-")) {
      this.salePriceStrike = 0;
      this.productPrice = this.utils.formatPrice(
        priceData.price || this.product.min_price
      );
      this.productWasPrice = this.utils.formatPrice(
        priceData.min_was_price || this.product.max_was_price
      );
      this.isPriceUpdate = true;

      // this.showSku = true;
       
      this.updatedPrice = this.utils.formatPrice(
        priceData.price || this.product.min_price
      );
      if (priceData.price != priceData.wasPrice) {
        this.salePriceStrike = priceData.wasPrice;
      }
    }
    this.isSetItemInInventory = (this.activeProduct.in_inventory || this.activeProduct.inventory_product_details.is_active === 1) ? true : false;
    this.activeProduct.in_inventory = (this.activeProduct.in_inventory || this.activeProduct.inventory_product_details.is_active === 1) ? true : false;
    this.showSku = ((this.activeProduct.inventory_product_details &&
      this.activeProduct.inventory_product_details.product_sku) ||
      (this.activeProduct.sku)) ? true : false;
  }


  openCartModal() {
    if (this.newVariationFound) {
      if (this.newVariationData.Skudetails.length > 0) {
        if (this.newSku) {
          this.saveCart();
        } else {
          document.getElementById('variationSection').scrollIntoView({ behavior: 'smooth' });

          this.hasSelection = false;
        }
      } else {
        if (
          this.newVariationData.selection.some((s) => s.requiredSelection == 0)
        ) {
          if (
            this.newSku.split("-").length - 1 ==
            this.newVariationData.selection.filter(
              (f) => f.requiredSelection !== 0
            ).length ||
            this.newSku.split("-").length - 1 ==
            this.newVariationData.selection.length
          ) {
            this.saveCart();
          } else {
            this.hasSelection = false;
            document.getElementById('variationSection').scrollIntoView({ behavior: 'smooth' });


          }
        } else {
          if (
            this.newSku.split("-").length - 1 !==
            this.newVariationData.selection.length
          ) {
            this.hasSelection = false;
            document.getElementById('variationSection').scrollIntoView({ behavior: 'smooth' });


          } else {
            this.saveCart();
          }
        }
      }
    } else {
      if (
        (!this.activeProduct.in_inventory &&
          !this.activeProduct.inventory_product_details.price) ||
        !this.beforeSelection
      ) {
        this.hasSelection = false;
        document.getElementById('variationSection').scrollIntoView({ behavior: 'smooth' });

      } else {
        if (this.activeProduct.in_inventory && this.activeProduct.inventory_product_details.price) {
          this.productPrice = this.activeProduct.inventory_product_details.price
        }
        this.saveCart();
      }
    }
  }

  saveCart() {
    this.hasSelection = true;
    // const data = {
    //   sku: this.activeProduct.sku,
    //   brand: this.product.brand_name,
    //   image: this.mainProductImage[0],
    //   name:
    //     this.activeProduct.sku === this.product.sku
    //       ? this.activeProduct.name
    //       : this.product.name + " " + this.activeProduct.name,
    //   price: this.productPrice,
    //   quantity: this.quantity,
    // };
    const postData = {
      product_sku:
        this.newVariationFound && this.newSku
          ? this.newSku : 
           (!this.newVariationFound && this.showSku && this.productSku) ? this.productSku :
           (this.product.inventory_product_details &&
             this.product.inventory_product_details.product_sku) ?
            this.product.inventory_product_details.product_sku :
            this.activeProduct.sku,
      parent_sku: (this.product.inventory_product_details && this.product.inventory_product_details.parent_sku) ?
        this.product.inventory_product_details.parent_sku
        : this.activeProduct.sku,
      count: this.quantity,
      room_id: this.page === 'client-shopping' ? this.roomId : this.selectedBookingId,
      is_virtual: this.newVariationFound && this.newSku ? 1 : 0,
    };

    localStorage.setItem('currentRoom', ''+this.selectedBookingId);

    if ((this.page === 'client-shopping' || this.page === 'ai-products' || this.page === 'search-keyword')) {
      delete postData.room_id;
      const data = {
        sku: this.activeProduct.sku,
        brand: this.product.brand_name,
        image: this.product.main_image,
        name:
          this.activeProduct.sku === this.product.sku
            ? this.activeProduct.name
            : this.product.name + " " + this.activeProduct.name,
        price: this.productPrice,
      product_data: this.product,
      page: this.page,
        quantity: this.quantity,
      designPriceFromSelection: this.designPriceFromSelection,
      hasSelection: this.newVariationFound ? true : false,


      };

      this.apiService.addCartProduct(postData).subscribe(
        (payload: any) => {
          if (payload.status) {
            this.errorMessage = "";
            if (this.page == 'product-catalogue') {
              this.snackbar.open('Added to Cart', 'x', { duration: 5000 });
            }
            if (this.page !== 'product-catalogue') {
              this.matDialogUtils.openAddToCartDialog(data);
            }
            // this.pixelService.trackAddToCart(data);
          } else {
            this.errorMessage = payload.msg;
          }
        },
        (error: any) => {
          this.errorMessage = "Cannot add this product at the moment.";
        }
      );
    } else {
      const data = {
        sku: this.activeProduct.sku,
        brand: this.product.brand_name,
        image: this.product.main_image,
        name:
          this.activeProduct.sku === this.product.sku
            ? this.activeProduct.name
            : this.product.name + " " + this.activeProduct.name,
        price: this.productPrice,
        quantity: this.quantity,
      };
      this.apiService.addDesignCartProduct(postData).subscribe((resp: any) => {
        if (resp.status) {
 
          this.snackbar.open("Product Added Successfully", "x", { duration: 2000 });
      
        } else {
          this.snackbar.open(resp.message, "x", { duration: 5000 });

        }
      },
        (error: any) => {
          this.errorMessage = "Cannot add this product at the moment.";
        });
    }



  }

  addUpgradeToCart(product: IUpgradeProduct) {
    const data = {
      sku: product.sku,
      brand: product.brand_name,
      image: product.image,
      name: product.name,
      price: product.price,
      quantity: 1,
    };
    const postData = {
      product_sku:
        (product.inventory_product_details && product.inventory_product_details.product_sku) ?
          product.inventory_product_details.product_sku
          : product.sku,
      parent_sku: (product.inventory_product_details && product.inventory_product_details.parent_sku) ?
        product.inventory_product_details.parent_sku
        : product.parent_sku,
      count: 1,
      isServiceRepOrder: 1,
      room_id: this.roomId,
      is_virtual: 0,
    };


    this.apiService.addCartProduct(postData).subscribe(
      (payload: any) => {
        if (payload.status) {
          this.errorMessage = "";
          this.snackbar.open('Added to Cart', 'x', { duration: 5000 });
 
          this.pixelService.trackAddToCart(data);
        } else {
          this.errorMessage = payload.msg;
        }
      },
      (error: any) => {
        this.errorMessage = "Cannot add this product at the moment.";
      }
    );
  }
  updatePrice(e) { 
    this.salePriceStrike = 0;
    this.designPriceFromSelection = +e.designPrice;
    this.updatedPrice = JSON.parse(JSON.stringify(this.product.min_price));
    let scenario1 =
      Math.floor(this.product.min_price) + Math.floor(e.sellingPrice);
    let scenario2 =
      Math.floor(this.product.min_was_price) + Math.floor(e.retailPrice);
    if (this.newVariationData.Skudetails.length > 0) {
      this.updatedPrice = +e.sellingPrice;
      if (Math.floor(e.retailPrice) != Math.floor(e.sellingPrice)) {
        this.salePriceStrike = Math.floor(e.retailPrice);
      }
    } else {
      this.updatedPrice = this.updatedPrice + +e.sellingPrice;
      if (scenario1 != scenario2) {
        this.salePriceStrike = scenario2;
      }
    }
    this.productPrice = this.utils.formatPrice(this.updatedPrice);

    this.isPriceUpdate = true;
  }
  getNewSku(event) { 
    if (event === undefined) {
      this.isSetItemInInventory = false;
      this.activeProduct.in_inventory = false;
      this.product.in_inventory = false;
      return;
    }
    if (this.newVariationData.Skudetails.length > 0 && event) {

      this.hasSelection = true;
      this.newSku = event;
      this.productSku = event;
      this.activeProduct.inventory_product_details.is_drop =
        this.newVariationData.Skudetails.find((f) => f.sku == event).is_drop;
      this.productSku = event;
      this.activeProduct.inventory_product_details.is_bo_drop =
        this.newVariationData.Skudetails.find((f) => f.sku == event).is_bo_drop;
      // if (this.newVariationData.Skudetails.length > 1) {
      //   this.mainProductImage[0] = this.newVariationData.Skudetails.find(
      //     (f) => f.sku == event
      //   ).imagePath
      //     ? this.newVariationData.Skudetails.find((f) => f.sku == event).imagePath
      //     : this.mainProductImage[0];
      // }
      this.activeProduct.in_inventory = (this.newVariationData.Skudetails.find(
        (f) => f.sku == event
      ).is_active) === 1 ? true : false;
      this.product.in_inventory = (this.newVariationData.Skudetails.find(
        (f) => f.sku == event
      ).is_active) === 1 ? true : false;

      this.isSetItemInInventory = (this.newVariationData.Skudetails.find(
        (f) => f.sku == event
      ).is_active) === 1 ? true : false;
      if (this.activeProduct.inventory_product_details && this.activeProduct.inventory_product_details.count &&
        this.activeProduct.inventory_product_details.count > 1
      ) {

      } else {
        this.activeProduct.inventory_product_details.count = 1;
      }
    } else {
      this.hasSelection = true;
      this.isSetItemInInventory = this.activeProduct.inventory_product_details.is_active === 1 ? true : false;
      this.activeProduct.in_inventory = this.activeProduct.inventory_product_details.is_active === 1 ? true : false;
      this.product.in_inventory = this.activeProduct.inventory_product_details.is_active === 1 ? true : false;
      this.newSku = this.product.sku + "-" + event;
    }
    // this.activeProduct.inventory_product_details = 
  }

  updateActiveProduct(product) { 
    if (

      this.product.variations.length === 1
    ) {
      let inv = product.variations[0].in_inventory;
      let invDetails = product.variations[0].inventory_product_details;

      if (!inv) { inv = product.in_inventory }
      if (!invDetails) { invDetails = product.inventory_product_details }
      this.activeProduct = {
        sku: product.variations[0].variation_sku,
        in_inventory: inv,
        name: product.variations[0].name,
        inventory_product_details:
          invDetails,
      };
      this.updatedPrice = Number(product.price);

    } else {
      this.activeProduct = {
        sku: product.variation_sku ? product.variation_sku : product.sku,
        in_inventory: product.in_inventory,
        name: product.name,
            inventory_product_details: product.inventory_product_details ? product.inventory_product_details : 
        (this.activeProduct && this.activeProduct.inventory_product_details) ?
         this.activeProduct.inventory_product_details 
          : []
      };
      this.updatedPrice = Number(this.activeProduct.inventory_product_details.price);
    }
  }
  quantityLimit(count) {
    const maxNumber = count < 10 ? count : 10;
    return Array.from({ length: maxNumber }, Number.call, (i) => i + 1);
  }

  hasVariationsInventory() {
    if (
      this.isVariationExist &&
      this.product.inventory_product_details === null
    ) {
      if (this.product.variations.find((item) => item.in_inventory === true)) {
        this.activeProduct.in_inventory = true;
        if (!this.activeProduct.inventory_product_details.count) {
          this.activeProduct.inventory_product_details.count = 1;
        }
      }
    }
  }

  onSetSelectionChecked(e: boolean) {
    this.beforeSelection = e;
    this.hasSelection = true;
    this.errorMessage = '';
  }

  onClearSelection(e: boolean) {
    this.checkSelection = e;
  }

  onSetSelection(e: boolean) {
    this.errorMessage = '';
    this.hasSelection = e;
  }



  isDiscounted(product): boolean {
    product.is_price = product.price;
    const price = this.utils.getPriceObject(product);
    return price.isDiscounted;
  }

  @HostListener("window:resize")
  onResize() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
  }
  goToBrandUrl(p) {
    if (p.product_url) {
      if (p.product_url.includes('http')) {
        window.open(p.product_url, '_blank');
      } else {
        window.open('https://' + p.product_url, '_blank');
      }
    }
  }


  selectTab(tab) {
    this.activeTab = tab;
  }
  ngOnDestroy(): void {
  }
  showInterCom() {
    (<any>window).Intercom(
      "showNewMessage",
      "Hi there! I see you would like to chat with a design consultant."
    );
  }
  updateImg(ind) {
    if (ind) {
      if (!this.mainProductImage) {
        this.mainProductImage.push(
          `${this.product.product_images_gallery[ind]}`
        );
      } else {
        this.mainProductImage[0] = `${this.product.product_images_gallery[ind]
          }`;
      }
    } else {
      this.mainProductImage[0] = this.product.main_image;
    }
  }
  clearSelection() {
    this.isPriceUpdate = false;
    this.newSku = "";
  }
  closeProductNav() {
    this.close.emit('close');
    if(this.location.path().includes('search') && this.isHandset){

      this.apiService.emitPreviewPanelBack$.next(true);
    }
   
  }
  back(){
        this.apiService.emitPreviewPanelBack$.next(true);

  }

  get rightPanelHeight() {
    return document.getElementById('rightPanel').offsetHeight;
  }

  get fullContentHeight() {
    if (!this.isHandset) {
      const heighgt = window.innerHeight;
      if (heighgt > 1150 && heighgt > (document.getElementById('fullContent')?.clientHeight) + 252) {
        return heighgt + 'px';
      } else {
        return (document.getElementById('fullContent')?.clientHeight) + 252 + 'px';
      }
    } else {
      return this.windowHeight + 'px'
    }
  }


  get showShipping(): boolean {
    if (this.showSku && this.utils.hasInventory(this.activeProduct) && this.activeProduct.inventory_product_details?.shipping_desc) {
      return true;
    }
    if (this.activeProduct.inventory_product_details && this.activeProduct.inventory_product_details.is_drop) {
      if (this.activeProduct.inventory_product_details.is_drop == '0'
        && (this.activeProduct.inventory_product_details.is_bo_lz || this.product.is_final == 1 || this.product.is_mto == 1)
      ) {
        return true;
// this.product.site === 'cb2' || this.product.site === 'cab' ||
      } else if (this.activeProduct.inventory_product_details.is_drop == '1'
        && (this.product.site === 'westelm' || 
          this.activeProduct.inventory_product_details.is_mto == '1'
          || (this.activeProduct.inventory_product_details.is_mto == '0' && this.activeProduct.inventory_product_details.is_bo_drop !== null)
        )
      ) {
        return true;

      } else if (this.activeProduct.inventory_product_details.is_drop == '2') {
        return true;

      }
    }
    return false;
  }

  get pdContentHeight() {
    if (!this.isHandset) {
      let h = 0;
      if (document.getElementById('pdContent')?.offsetHeight < 400) {
        h = (document.getElementById('pdContent')?.offsetHeight) * 3;

      } else if (document.getElementById('pdContent')?.offsetHeight > 400 &&
        (document.getElementById('pdContent')?.offsetHeight < 600 && this.windowHeight < 800)) {
        h = (document.getElementById('pdContent')?.offsetHeight) * 2;

      } else {
        h = (document.getElementById('pdContent')?.offsetHeight) * 3;
      }
      if (h > (this.windowHeight)) {
        return h + 'px';

      } else {
        return this.windowHeight + 'px';
      }
    } else {
      return this.windowHeight + 'px'
    }
  }
  get isDisabled() {
    const condition = this.selectedBookingId || this.page === 'client-shopping' || this.page === 'ai-products'
      || this.page === 'search-keyword';
    if (condition) {
      if (this.isVariationExist &&
        this.product.product_status === 'active'
        && !this.product.redirect &&
        this.product.variations?.length > 0 && this.showSku && this.productSku && condition) {
        return false;
      } else if (this.product.product_status === 'active' && this.newVariationFound && this.newSku && condition) {
        return false;
      } else if (this.isVariationCallLoading) {
        return true;
      }
      if (!this.isVariationExist && condition) {
        return false;

      } else {
        return true;

      }
    }
    return true;
  }


  plusSlides(n: number,type) {
    this.showSlides((this.slideIndex += n),type);
  }
  currentSlide(n,type) {
    this.showSlides((this.slideIndex = n),type);
  }
  showSlides(n,type) {
    let i;
    let slides:any;
    let dots:any;

  slides = document.getElementsByClassName(
     type==='dims'? "pDimsSlides": "pSlides"
    ) as HTMLCollectionOf<HTMLElement>;

    if (slides.length > 0) {
        dots = type==='dims'? document.getElementsByClassName("dims-dot"):document.getElementsByClassName("dot");
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active-dot", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      if (dots && dots[this.slideIndex - 1]) {
        dots[this.slideIndex - 1].className += " active-dot";
      }
    }
  }

         get allowedUser(){
    return (''+this.userType)=='0' ||(''+this.userType)=='1' 
  }

  get isDesigner(){

    return (''+this.userType)=='70' ||(''+this.userType)=='90'

  }

    get canSeeDesignPricing(){
      const userType = ''+this.userType;
    return (userType == '2' || userType == '70' || userType == '90' )&& 
    this.product.inventory_product_details?.design_price || (this.product.design_max_price ||this.product.design_min_price &&(
      this.product.design_min_price!==0 ||
    this.product.design_max_price!==0))
  }
    get canSeeDesignPricingFromSelection(){
      const userType = ''+this.userType;
    return (userType == '2' || userType == '70' || userType == '90' )&& 
    this.designPriceFromSelection>0
  }

}

